var collapsible_list_component_rtlignore_default = {
  "ltr": "aF2XI",
  "rtl": "_3r--k",
  "iconContainer": "yial3",
  "icon": "r0fwf",
  "isExpanded": "hc6Zw",
  "listDimensions": "Ye6KI"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore-scss.js.map
